/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import { processLinkData } from '../../../utils/analytics';
import createButtonCss from '../Button/Button';
import { Link } from '@sitecore-jss/sitecore-jss-react';
import { iconCss, linkCss } from './index.styles';

class LinkWrapper extends SafePureComponent {
  renderIcon = iconName => {
    const { invert } = this.props;
    return <span css={iconCss(invert)} className={`icon-${iconName}`}></span>;
  };

  executeOnClick = e => {
    e.preventDefault();
    const { componentName, onClick, isGTMTrackable, field } = this.props;
    processLinkData(componentName, field, isGTMTrackable, onClick);
    return true;
  };

  safeRender() {
    const {
      children,
      css,
      field,
      iconType,
      invert,
      showLinkTextWithChildrenPresent,
      options,
      type,
      sitecoreContext,
      ...restProps
    } = this.props;
    const isEditing = get(sitecoreContext, 'pageEditing', false);
    const isExternal = get(field, 'value.linktype') === 'external';

    const baseProps = {
      css: [createButtonCss(type, options), linkCss(invert), css],
      field: field,
      ...restProps,
    };

    if (isEditing) {
      return <Link {...baseProps} />;
    }

    if (iconType || isExternal) {
      return (
        <Link
          showLinkTextWithChildrenPresent
          {...baseProps}
          onClick={e => this.executeOnClick(e)}
        >
          {children}
          {isExternal && this.renderIcon('external')}
          {iconType && !isExternal && this.renderIcon(iconType)}
        </Link>
      );
    }

    return (
      <Link
        showLinkTextWithChildrenPresent={showLinkTextWithChildrenPresent}
        {...baseProps}
        onClick={e => this.executeOnClick(e)}
      >
        {children}
      </Link>
    );
  }
}

LinkWrapper.displayName = 'LinkWrapper';

LinkWrapper.defaultProps = {
  css: {},
  field: { value: {} },
  iconType: '',
  invert: false,
  onClick: () => {},
  showLinkTextWithChildrenPresent: false,
  options: { theme: 'light' },
  type: 'primary',
  componentName: '',
};

LinkWrapper.propTypes = {
  css: PropTypes.object,
  field: PropTypes.shape({
    value: PropTypes.shape({
      href: PropTypes.string.isRequired,
      linktype: PropTypes.oneOf(['internal', 'external']),
      text: PropTypes.string,
      target: PropTypes.string,
    }),
  }),
  iconType: PropTypes.string,
  componentName: PropTypes.string,
  invert: PropTypes.bool,
  onClick: PropTypes.func,
  showLinkTextWithChildrenPresent: PropTypes.bool,
  options: PropTypes.shape({ theme: PropTypes.string }),
  type: PropTypes.oneOf(['primary', 'secondary']),
};

export default withSitecoreContext()(LinkWrapper);
